import * as mns from '../../../mutation-types';

export default {
    state () {
        return {
            applicantPersonType: 'InsuredPerson',
        }
    },
    getters: {
        applicantPersonType(state){
            return state.applicantPersonType;
        },
    },
    mutations: {
        [mns.SET_APPLICANT_PERSON_TYPE](state, applicantPersonType){
            state.applicantPersonType = applicantPersonType;
        },
    }
} // export.